<app-auth-layout>
  <h2>Establecer nueva contraseña</h2>
      <br>
      <!-- <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="default" color=" var(--primary-color)" type="ball-atom"
        [fullScreen]="false"></ngx-spinner> -->

      <form [formGroup]="passwordForm">
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nueva contraseña</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" id="ClaveNueva" formControlName="ClaveNueva" (input)="onPasswordInput()"/>
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Ocultar contraseña'"
                [attr.aria-pressed]="hide">
                <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
              </button>

              <button mat-icon-button matSuffix class="no-ripple-button" disabled="true"
                    [matTooltip]="passwordStrength?.strength || 'Seguridad desconocida'"
                    [ngClass]="passwordStrength?.class || ''">

                    <mat-icon *ngIf="passwordStrength?.class; else defaultIcon"
                      [ngClass]="passwordStrength?.class">shield</mat-icon>

                  </button>

                  <ng-template #defaultIcon>
                    <mat-icon class="shield-default">shield</mat-icon>
                  </ng-template>


              <mat-error *ngIf="passwordForm.controls['ClaveNueva'].hasError('required')">Ingrese clave nueva.
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['ClaveNueva'].hasError('MustMatch')">Las claves no coinciden.
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['ClaveNueva'].hasError('minlength')">Debe superar los 8
                caracteres.
              </mat-error>
              <mat-error matTooltip="La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una minúscula, un número y un carácter especial." *ngIf="passwordForm.controls['ClaveNueva'].hasError('pattern')">
                La clave con cumple con las politicas.
              </mat-error>
            </mat-form-field>

          </div>
        </div>

        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Confirme la contraseña</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" id="ClaveNuevaRepetir"
                formControlName="ClaveNuevaRepetir" />
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Ocultar contraseña'"
                [attr.aria-pressed]="hide">
                <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
              <mat-error *ngIf="passwordForm.controls['ClaveNuevaRepetir'].hasError('required')">Repita clave nueva.
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['ClaveNuevaRepetir'].hasError('mustMatch')">Las claves no
                coinciden.
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['ClaveNuevaRepetir'].hasError('minlength')">Las Debe superar los 8
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <button mat-raised-button color="primary" class="w-100" [disabled]="!passwordForm.valid"
              (click)="changePassword()">
              Restablecer contraseña
            </button>
          </div>
        </div>
      </form>
</app-auth-layout>
